<script>

export default {
  name: 'avaliacao-tema',
  props: {
    avaliacao: Object,
    etapa: String
  },
  data () {
    return {}
  },
  computed: {
    temas: {
      get () {
        return this.avaliacao.temas
      }
    },
    tema: {
      get () {
        return this.avaliacao.tema
      },
      set (tema) {
        this.avaliacao.tema = tema
        this.$emit('update:avaliacao', this.avaliacao)
      }
    }
  },
  mounted () {
  },
  methods: {
    continuar () {
      this.$emit('update:etapa', 'redacao')
    }
  }
}

</script>
<template>
  <div class="avaliacao-tema">
    <div class="page-content">
      <div class="page-header-content">
        <h2 class="page-title">Selecione o tema</h2>
      </div>
    </div>

    <div class="box pa-3">
      <v-radio-group v-model="tema" class="ma-0 pa-3 lista-temas">
        <div v-for="(tema, i) in temas">
          <v-radio
            color="primary"
            :key="tema.titulo"
            :value="tema"
          >
            <template v-slot:label>
              <div>
                <h3 class="title font-weight-regular black--text mb-1">{{ tema.titulo }}</h3>
                (<a :href="tema.enunciado" target="_blank">Clique aqui para visualizar o enunciado</a>)
              </div>
            </template>
          </v-radio>

          <v-divider class="my-3" v-if="i !== temas.length-1"/>
        </div>
      </v-radio-group>

      <div class="text-xs-right">
        <v-btn color="primary"
               depressed
               large
               @click="continuar()"
               class="ma-0">
          <i class="fas fa-arrow-circle-right"></i>
          <span class="pl-1">Continuar</span>
        </v-btn>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.avaliacao-tema {
  .lista-temas .v-input__control {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// Tema.vue?4ab0dbe7